import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { CONTENTS_JSON_KEY } from './keys';
import { ContentsApi } from 'api';

function useGetJson(id: string) {
  return useAuthQuery(
    getQueryKeys(CONTENTS_JSON_KEY).detail(id),
    () => ContentsApi.getJSON(id),
    {
      select: (data) => data.data.data,
    },
  );
}

export default useGetJson;
